<template>
  <Layout style="height: 100%;width: 100%;">
    <Row style="height: 100%;margin: 10px;" >
      <Col span="3" style="height: 100%">
      <Card style="height: 100%" v-if="currentUser != null">
        <P>医助详情</P>
        <img v-if="currentUser != null" :src="currentUser.imageUrl" style="height: 80px;width: 80px"/>
        <p>登录姓名：{{currentUser.loginName ? currentUser.loginName : ''}}</p>
        <p>真实姓名：{{currentUser.realName}}</p>
        <p>拥有角色：{{currentUser.role === undefined ||currentUser.role.length === 0 ?'':currentUser.role.join(",")}}</p>
        <p>账号状态：{{currentUser.isLock?"已禁用":"在使用"}}</p>
      </Card>
      </Col>
      <Col span="21">
      <section class="home-container" style="height: 100%;margin-left: 10px">
        <MasterPage title="患者列表" style="height: 100%;overflow-y: auto" :style="{height: wrapHeight + 'px'}">
          <div slot="title-icon">
            <Icon type="ios-pulse" />
          </div>
          <div slot="searchContent" class="search-content-slot">
            <Row>
              <Form :label-width="80">
                <Col span="6">
                <FormItem label="患者姓名：">
                  <Input v-model="queryValue.name" placeholder="请输入" clearable prefix="ios-search" @on-enter="getPatientList"/>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="手机号：">
                  <Input v-model="queryValue.phone" placeholder="请输入" clearable prefix="ios-search" @on-enter="getPatientList"/>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="诊断类型：">
                  <Select v-model="queryValue.selectValue" @on-change="getPatientList" clearable>
                    <Option v-for="item in selectList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
                </Col>
                <!--<Col span="6">-->
                <!--<FormItem label="诊断：">-->
                  <!--<Select v-model="queryValue.isAutism" @on-change="getPatientList" clearable>-->
                    <!--<Option v-for="item in isAutismList" :value="item.value" :key="item.value">{{ item.label }}</Option>-->
                  <!--</Select>-->
                <!--</FormItem>-->
                <!--</Col>-->
                <Col span="6">
                <FormItem label="诊断状态：">
                  <Select v-model="queryValue.status" @on-change="getPatientList" clearable>
                    <Option v-for="item in patientStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="诊断：">
                  <Select v-model="queryValue.diagnose" @on-change="getPatientList" clearable>
                    <Option v-for="item in diagnoseItems" :value="item" :key="item">{{ item}}</Option>
                  </Select>
                </FormItem>
                </Col>
                <Col span="18">
                <div style="display: flex;flex-direction: row;justify-content: flex-end">
                  <Button type="info" icon="ios-search" @click="getPatientList">查询</Button>
                </div>
                </Col>
              </Form>
            </Row>
          </div>
          <div slot="paddingContent">
            <Table :columns="columns1" :data="dataListModel.dataList"></Table>
          </div>
          <div slot="pager">
            <Page :total="dataListModel.pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="dataListModel.pageSize" show-total show-elevator show-sizer/>
          </div>
        </MasterPage>
      </section>
      </Col>
    </Row>

    <Modal v-model="patientDetailsModel.openPatientDetails" title="患者详情" width="700">
      <Form :label-width="80">
        <Row>
          <Col span="12">
          <FormItem label="患者头像：">
            <img :src="patientDetailsModel.data.profileImgUrl" style="max-height: 125px;max-width: 100%">
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="诊断状态：">{{patientDetailsModel.data.isFirst? '首诊' : '随诊'}}</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="患者编号：">{{patientDetailsModel.data.id}}</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="患者名称：">{{patientDetailsModel.data.name}}</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="患者性别：">{{patientDetailsModel.data.sex === '0'?'男':patientDetailsModel.data.sex === '1'?'女':'-'}}</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="患者账号：">{{patientDetailsModel.data.phone}}</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="患者生日：">{{patientDetailsModel.data.birthday ? moment(patientDetailsModel.data.birthday).format('YYYY-MM-DD ') : ''}}</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="患者身高：">{{patientDetailsModel.data.height}}cm</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="患者体重：">{{patientDetailsModel.data.weight}}kg</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="患者状态：">{{patientDetailsModel.data.isLock?"已禁用":"在使用"}}</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="创建时间：">{{moment(patientDetailsModel.data.createTime).format('YYYY-MM-DD HH:mm:ss')}}</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="邮箱：">{{patientDetailsModel.data.email}}</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="住址：">{{patientDetailsModel.data.address}}</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="监护人姓名：">{{patientDetailsModel.data.guardianName}}</FormItem>
          </Col>
          <Col span="12">
          <FormItem label="备用联系电话：">{{patientDetailsModel.data.connectPhone}}</FormItem>
          </Col>
          <Col span="24" style="margin-bottom: 20px">
              <Col span="6" v-if="patientDetailsModel.data.diagnose != null" style="display: flex; justify-content: center">
          <!--<Button type="primary" shape="circle" icon="ios-pulse-outline"-->
                  <!--to="/doctor_manage/medicalRecords">添加处方</Button>-->
          <!--<Button type="primary" shape="circle" icon="ios-pulse-outline"-->
                  <!--:to="patientDetailsModel.data.isFirst ? '/doctor_manage/medicalRecords' : '/doctor_manage/medicalRecordsFollow'">添加处方</Button>-->
          <Button type="primary" shape="circle" icon="ios-pulse-outline"
                  :to="'/doctor_manage/medicalRecords'">添加处方</Button>
          </Col>
              <Col span="6" v-if="patientDetailsModel.data.diagnose != null" style="display: flex; justify-content: center">
            <Button type="primary" shape="circle" icon="ios-paper-outline"
                    to="/doctor_manage/diagnoseHistory"
            >诊断历史</Button>
            </Col>
              <Col span="6" style="display: flex; justify-content: center">
                 <Button type="primary" shape="circle" icon="md-add" @click="goPatientReport()">查看报告</Button>
              </Col>
              <Col span="6" style="display: flex; justify-content: center">
                 <Button type="primary" shape="circle" icon="md-add" to="/doctor_manage/questionWrite">填写问卷</Button>
              </Col>
          <Col span="6" style="display: flex; justify-content: center;margin-top: 5px">
          <Button type="primary" shape="circle" icon="md-add" @click="goUserOrder(patientDetailsModel.data)">检测订单</Button>
          </Col>
          </Col>
          <Col span="24">
          <FormItem label="饮食原则：">
            <Table stripe max-height="250" :columns="userDietGuidelinesTitle" :data="userDietGuidelines"></Table>
          </FormItem>
          <FormItem label="联系人：">
            <Table stripe max-height="250" :columns="patientDetailsModel.connectTitle" :data="patientDetailsModel.data.connectList"></Table>
          </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  </Layout>
</template>

<script>
  import Moment from 'moment'
  import MasterPage from '../../components/Master'
  export default {
    name: "show-info-module",
    components: {
      Moment,
      MasterPage
    },
    data() {
      return {
          wrapHeight: window.innerHeight - 68,
        moment: Moment,
          currentUser: null,
         columns1: [
                    {
                        title: '患者姓名',
                        align: 'center',
                        key: 'name',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px',
                                        minHeight: '23px',
                                        minWidth: '24px'
                                    },
                                    on: {
                                        click: () => {
                                            this.onClickPatientName(params.row)
//                                            this.onClickPatientDetails(params.row)
                                        }
                                    }
                                }, params.row.name)
                            ]);
                        }
                    },
                    {
                        title: '性别',
                        align: 'center',
                        key: 'sex',
                        render: (h, params) => {
                         return h('span', params.row.sex ==='0' ? '男' :params.row.sex ==='1'?'女':'-')
                        }
                    },
                   {
                        title: '注册日期',
                        align: 'center',
                        key: 'createTime',
                       render: (h, params) => {
                         return h('span', this.moment(params.row.createTime).format('YYYY-MM-DD '))
                        }
                    },
                    {
                        title: '联系电话',
                        align: 'center',
                        key: 'phone'
                    },
             {
                 title: '出生日期',
                 align: 'center',
                 key: 'birthday',
                 render: (h, params) => {
                     return h('span', this.moment(params.row.brithday).format('YYYY-MM-DD '))
                 }
             },
             {
                 title: '诊断',
                 align: 'center',
                 key: 'diagnoseContent',
                 render: (h, params) => {
                     return h('span', params.row.diagnoseContent)
                 }
             },
                    {
                        title: '诊断类型',
                        align: 'center',
                        key: 'isFirst',
                       render: (h, params) => {
                         return h('span', params.row.isFirst? '首诊' : '随诊')
                        }
                    },
             {
                 title: '病历填写时间',
                 align: 'center',
                 key: 'recordCreateTime',
                 render: (h, params) => {
                     return h('span', params.row.recordCreateTime ?
                         this.moment(params.row.recordCreateTime).format('YYYY-MM-DD ') : '')
                 }
             },
                      {
                        title: '邮箱',
                        key: 'email',
                        align: 'center',
                        ellipsis: true,
                        tooltip: true
                    },
                    // {
                    //     title: '住址',
                    //     key: 'address',
                    //     align: 'center',
                    //     ellipsis: true,
                    //     tooltip: true
                    // },
                    // {
                    //     title: '监护人姓名',
                    //     key: 'guardianName',
                    //     align: 'center',
                    //     ellipsis: true,
                    //     tooltip: true
                    // },
                    // {
                    //     title: '备用联系电话',
                    //     key: 'connectPhone',
                    //     align: 'center',
                    //     ellipsis: true,
                    //     tooltip: true
                    // },
//                   {
//                          title: '操作',
//                          key: 'action',
//                       width:200,
//                          align: 'center',
//                          render: (h, params) => {
//                              return h('div', [
//                                  h('Button', {
//                                      props: {
//                                          type: 'primary',
//                                          size: 'small'
//                                      },
//                                      style: {
//                                          marginRight: '5px'
//                                      },
//                                      on: {
//                                          click: () => {
//                                            // this.onClickPatientDetails(this.dataListModel.dataList[params.index])
//                                            this.onClickPatientDetails(params.row)
//                                          }
//                                      }
//                                  }, '详情'),
//                                  h('Button', {
//                                      props: {
//                                          type: 'primary',
//                                          size: 'small'
//                                      },
//                                      on: {
//                                          click: () => {
//                                              // this.onClickPatientDetails(this.dataListModel.dataList[params.index])
//                                              this.goUserOrder(params.row)
//                                          }
//                                      }
//                                  }, '检测')
//                              ]);
//                          }
//                      }
                ],
        selectList: [
          {
            value: 'true',
            label: '首诊'
          },
          {
            value: 'false',
            label: '随诊'
          }
        ],
          isAutismList: [
              {
                  value: 'true',
                  label: '是'
              },
              {
                  value: 'false',
                  label: '否'
              }
          ],
          diagnoseItems: ["孤独症谱系障碍", "多动症", "抽动症", "哮喘", "过敏性鼻炎", "腺样体肥大", "湿疹/特应性皮炎", "系统性红斑狼疮", "干燥综合症", "类风湿关节炎", "多发性肌炎/皮肌炎", "自身免疫性肝病/原发性胆汁性肝硬化", "功能性胃肠病", "炎结肠病（溃疡性结肠炎，克隆氏病）", "抑郁症", "焦虑症", "老年痴呆", "帕金森病", "艰难梭菌感染", "伪膜性肠炎", "肠道菌群失调"],
          patientStatus: [
              {
                  value: 'false',
                  label: '待诊断'
              },
              {
                  value: 'true',
                  label: '已诊断'
              }
          ],
          userDietGuidelinesTitle:[
              {
                  type: 'index',
                  width: 50,
                  align: 'center',
              },
              {
                  title: '原则名称',
                  key: 'name',
                  align: 'center',
              },
//              {
//                  title: '禁食界限',
//                  key: 'detailList',
//                  tooltip: true,
//                  align: 'center',
//                  render: (h, params) => {
//                      if (params.row.detailList.length === 0) {
//                          return
//                      }
//                      return h("span", params.row.detailList[0].name)
//                  }
//              }
              ],
        patientDetailsModel: {
          openPatientDetails: false,
          connectTitle:[
            {
              type: 'index',
              width: 50,
              align: 'center',
            },
            {
              title: '联系人姓名',
              key: 'name',
              align: 'center',
            },
            {
              title: '联系人号码',
              key: 'phone',
              tooltip: true,
              align: 'center',
            },
            {
              title: '联系人地址',
              key: 'address',
              tooltip: true,
              align: 'center'
            }
          ],
          data: {
            profileImgUrl: null,
            id: null,
            name: null,
            sex: null,
            phone: null,
            birthday: null,
            height: null,
            weight: null,
            isLock: 'false',
            createTime: null,
            connectList: []
          }
        },
          userDietGuidelines: [],
        queryValue:{
          name:'',
          phone: '',
          selectValue: '',
            isAutism: '',
            status: 'false',
            diagnose: ''
        },
        dataListModel: {
          pageNum:1,
          pageSize:20,
          pageTotal:0,
          dataList:[]
        }
      }
    },
    methods: {
        pageChange(value){
            this.dataListModel.pageNum = value
            this.getPatientList()
        },
        pageSizeChange(value){
            this.dataListModel = pageSize
            this.getPatientList()
        },
      getPatientList(vale){
        this.$Message.loading('正在加载中。。。')
          let params = {
              isAutism: this.queryValue.isAutism ? this.queryValue.isAutism : null,
              isFirst: this.queryValue.selectValue ? this.queryValue.selectValue : null,
              diagnose: this.queryValue.status ? this.queryValue.status : null,
              name: this.queryValue.name,
              phone: this.queryValue.phone,
              isLock:'false',
              pageSize:this.dataListModel.pageSize,
              pageNum:this.dataListModel.pageNum,
          }
          if (this.queryValue.diagnose != null && this.queryValue.diagnose != '') {
              params['diagnoseContent'] = this.queryValue.diagnose
          }
        this.$http.post('user/list', params).then(function (res) {
          let msg = res.body
          if (msg.success) {
            this.dataListModel.dataList = msg.data.list
            this.dataListModel.pageTotal = msg.data.total
          }else {
            this.$Notice.error({title:'患者账户查询失败',desc: msg.message});
          }
        },function (res) {
          this.myError(res.body)
        })
      },
        onClickPatientName (value) {
//            this.getDietlineByUser()
            this.patientDetailsModel.data =value
            this.$store.commit('setCurrentPatient', value)
            sessionStorage.setItem('currentPatient', JSON.stringify(value))
            this.$router.replace('/doctor_manage/medicalRecords')
        },
      onClickPatientDetails(value) {
        if (this.patientDetailsModel.openPatientDetails) {
          this.patientDetailsModel.openPatientDetails = false
          this.patientDetailsModel.data= null
        }else {
          this.patientDetailsModel.openPatientDetails =true
          this.patientDetailsModel.data =value
          this.getDietlineByUser()
          this.$store.commit('setCurrentPatient', value)
            sessionStorage.setItem('currentPatient', JSON.stringify(value))
        }
      },
        goPatientReport () {
          this.$router.push({name: 'patientReport', params:{patient: this.patientDetailsModel.data}})
        },
        // 患者检测订单
        goUserOrder (item) {
            this.$router.push({name: 'userTestOrder', params:{patient: item}})
        },
        getDietlineByUser () {
            this.$http.post('dietGuidelines/listUser',{
                userId: this.patientDetailsModel.data.id
            }).then(function (res) {
                let msg = res.body
                if (msg.success) {
                    this.userDietGuidelines = msg.data
                }else {
                    this.$Notice.error({title:'饮食原则查询失败',desc: msg.message});
                }
            },function (res) {
                this.myError(res.body)
            })
        }
    },
    created(){
        this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'))
      this.getPatientList()
    }
  }
</script>

<style scoped>
</style>
